/**
 * AFU Remote 頁面配置
 *
 * 定義所有 afu 模組的頁面，自動生成：
 * - vite.config exposes
 * - remoteModules
 * - pagePermissions
 * - sideNavMenus
 */

import type { RemoteModuleConfig, PageConfig } from './types';

// ============================================================================
// 頁面配置
// ============================================================================

export const pages: PageConfig[] = [
    // === 主要功能 ===
    {
        name: 'Cases',
        path: './views/Cases.vue',
        title: '案件管理',
        mode: 'workflow',
        icon: 'icofont-clip',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 1 },
    },
    {
        name: 'Tasks',
        path: './views/Tasks.vue',
        title: '任務管理',
        mode: 'workflow',
        icon: 'icofont-check-circled',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 2 },
    },
    {
        name: 'CreateCase',
        path: './views/CreateCase.vue',
        title: '建立案件',
        mode: 'workflow',
        icon: 'icofont-plus-circle',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 3 },
    },
    {
        name: 'CaseDetail',
        path: './views/CaseDetail.vue',
        title: '案件詳情',
        mode: 'workflow',
        icon: 'icofont-info-circle',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'CaseFlow',
        path: './views/CaseFlow.vue',
        title: '流程看板',
        mode: 'workflow',
        icon: 'icofont-chart-flow-1',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 4 },
    },
    {
        name: 'MyTasks',
        path: './views/MyTasks.vue',
        title: '我的任務',
        mode: 'workflow',
        icon: 'icofont-tasks',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 5 },
    },
    // === 案件子頁面 ===
    {
        name: 'CaseContract',
        path: './views/CaseContract.vue',
        title: '合約管理',
        mode: 'workflow',
        icon: 'icofont-file-document',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'CaseEngineering',
        path: './views/CaseEngineering.vue',
        title: '工程資料',
        mode: 'workflow',
        icon: 'icofont-tools-alt-2',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'CaseEquipment',
        path: './views/CaseEquipment.vue',
        title: '設備管理',
        mode: 'workflow',
        icon: 'icofont-cpu',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'CasePlanningBook',
        path: './views/CasePlanningBook.vue',
        title: '規劃簿',
        mode: 'workflow',
        icon: 'icofont-book-mark',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'ChangedTask',
        path: './views/ChangedTask.vue',
        title: '變更記錄',
        mode: 'workflow',
        icon: 'icofont-history',
        default: false,
        showInSideNav: false,
    },
    {
        name: 'TaskSchedule',
        path: './views/TaskSchedule.vue',
        title: '任務排程',
        mode: 'workflow',
        icon: 'icofont-calendar',
        default: false,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 6 },
    },
];

// ============================================================================
// 模組完整配置
// ============================================================================

export const config: RemoteModuleConfig = {
    name: 'afu',
    federationName: 'afu_remote',
    port: 7002,
    pages,
};

export default config;
